import { TApiResponse } from '@/common/types/response';

import { TVedCommonState } from '@/modules/ved/store/vedCommon/types';

import { TFTSCommonState } from './types';

export function setCustomsProcedures(state: TFTSCommonState, res: TApiResponse<TFTSCommonState['customsProcedures']>) {
  state.customsProcedures = res.data;
}

export function setProductsGroups(state: TFTSCommonState, res: TApiResponse<TFTSCommonState['productsGroups']>) {
  state.productsGroups = res.data;
}

export function setProductsTwoSigns(state: TFTSCommonState, res: TApiResponse<TFTSCommonState['productsTwoSigns']>) {
  state.productsTwoSigns = res.data;
}

export function setProductsFourSigns(state: TFTSCommonState, res: TApiResponse<TFTSCommonState['productsFourSigns']>) {
  state.productsFourSigns = res.data;
}

export function setProductsSixSigns(state: TFTSCommonState, res: TApiResponse<TFTSCommonState['productsSixSigns']>) {
  state.productsSixSigns = res.data;
}

export function setProductsEightSigns(
  state: TFTSCommonState,
  res: TApiResponse<TFTSCommonState['productsEightSigns']>,
) {
  state.productsEightSigns = res.data;
}

export function setProductsNineSigns(state: TFTSCommonState, res: TApiResponse<TFTSCommonState['productsNineSigns']>) {
  state.productsNineSigns = res.data;
}

export function setProductsTenSigns(state: TFTSCommonState, res: TApiResponse<TFTSCommonState['productsTenSigns']>) {
  state.productsTenSigns = res.data;
}

export function setOkatoTree(state: TFTSCommonState, res: TApiResponse<TFTSCommonState['okatoTree']>) {
  state.okatoTree = res.data;
}

export function setCountriesTree(state: TVedCommonState, response: TApiResponse<TFTSCommonState['countriesTree']>) {
  state.countriesTree = response.data;
}
